module.exports = function ($compileProvider) {
    $compileProvider.debugInfoEnabled('wowIsDebuggingEnabled' in window ? !!window.wowIsDebuggingEnabled : true);
};



// WEBPACK FOOTER //
// ./src/configuration/compile.js